import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import { i18n } from './language';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'titles.home',
      },
    },
    {
      path: '/clues',
      name: 'clues',
      component: () => import(/* webpackChunkName: "clues" */ './views/Clues.vue'),
      meta: {
        title: 'titles.clues',
      },
    },
    {
      path: '/quiz',
      name: 'quiz',
      component: () => import(/* webpackChunkName: "clues" */ './views/Quiz.vue'),
      meta: {
        title: 'titles.quiz',
      },
    },
    {
      path: '/status',
      name: 'status',
      component: () => import(/* webpackChunkName: "clues" */ './views/Status.vue'),
      meta: {
        title: 'titles.status',
      },
    },
  ],
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = i18n.t(nearestWithTitle.meta.title, nearestWithTitle.meta.options);

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach((key) => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  }).forEach(tag => document.head.appendChild(tag));

  return next();
});

export default router;
